module.exports = __webpack_public_path__ + "static/salebg-832cf78f6d56e65497cbdc07676364ed.jpg";